import {
  FETCH_ESSENTIAL_EXTRAS_REQUEST,
  FETCH_ESSENTIAL_EXTRAS_SUCCESS,
  FETCH_ESSENTIAL_EXTRAS_FAILURE,
  FETCH_EXTRAS_DATA_REQUEST,
  FETCH_EXTRAS_DATA_SUCCESS,
  FETCH_EXTRAS_DATA_FAILURE
} from '../../actionTypes/essentialExtrasActionTypes'

const fetchEssentialExtrasRequest = payload => ({
  type: FETCH_ESSENTIAL_EXTRAS_REQUEST,
  payload
})

const fetchEssentialExtrasSuccess = payload => ({
  type: FETCH_ESSENTIAL_EXTRAS_SUCCESS,
  payload
})

const fetchEssentialExtrasFailure = payload => ({
  type: FETCH_ESSENTIAL_EXTRAS_FAILURE,
  payload
})

const fetchExtraDataRequest = payload => ({
  type: FETCH_EXTRAS_DATA_REQUEST,
  payload
})

const fetchExtraDataSuccess = payload => ({
  type: FETCH_EXTRAS_DATA_SUCCESS,
  payload
})

const fetchExtraDataFailure = payload => ({
  type: FETCH_EXTRAS_DATA_FAILURE,
  payload
})

export {
  fetchEssentialExtrasRequest,
  fetchEssentialExtrasSuccess,
  fetchEssentialExtrasFailure,
  fetchExtraDataRequest,
  fetchExtraDataSuccess,
  fetchExtraDataFailure
}
